@for (item of items; track item) {
  <div class="{{ item.colour_scheme }} item" class="">
    <div class="item-contents" (click)="navigate(item)">
      <div class="image">
        <img
          alt="{{ item.menu_title }}"
          loading="lazy"
          [src]="getImageUrl(item)"
          />
      </div>
      <div class="description heart-description">
        <h3>{{ item.menu_title }}</h3>
        <div
          class="heart-icon"
          (click)="toggleFavourite(item); $event.stopPropagation()"
          >
          <i [class]="item.favourited ? 'fa fa-heart' : 'fa fa-heart-o'"></i>
        </div>
      </div>
      <div class="item-price">
        <product-list-price [product]="item"></product-list-price>
      </div>
    </div>
  </div>
}
